<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary pos-relative daily-performance {{
		widgetClass
	}}"
	style="min-height: 23em"
	[ngClass]="{ 'r8-daily-stats': isR8, 'no-data-content': !hasData }"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<!-- this below span is for ltr2 where we need header in no data scenariio -->
	<span *ngIf="!hasData" class="header"></span>
	<div
		*ngIf="hasData"
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom pos-relative custom-primary"
	>
		<div class="o-stack__cell">
			<h5>
				{{ sectiontitle }}
				<span class="downloadIconHeader">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadDataInCSV($event)"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload && hasData"
					>
						<img class="downloadIcon" src="{{ downloadIcon }}" />
					</a>
				</span>
			</h5>
		</div>
	</div>
	<div class="analytics-portlet-content" [ngClass]="{ 'no-daily-stats-data': !hasData }">
		<div style="width: 100%; height: 100%" class="daily-stats-graph">
			<div id="chart" #graphArea></div>
		</div>
		<div class="no-data-container" *ngIf="!hasData">
			<div
				style="width: 100%; position: absolute; top: 15px"
				class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom pos-relative custom-primary"
			>
				<div class="o-stack__cell">
					<h5>{{ sectiontitle }}</h5>
				</div>
			</div>
			<div class="map-no-data">No Data to Display</div>
		</div>
	</div>
</div>
